/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Path } from '../models/Path';

export class FileRestoreData {
  /**
  * List of file paths to restore.
  */
  'files': Array<Path>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "files",
      "baseName": "files",
      "type": "Array<Path>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FileRestoreData.attributeTypeMap;
  }

  public constructor() {
  }
}

